export default {
    beforeRouteLeave(_to, _from, next) {
        // Check if the UnsavedChecker component is available
        if (this.$refs.unsavedChecker) {
            // Delegate to the UnsavedChecker component to handle navigation
            this.$refs.unsavedChecker.interceptNavigation(next);
        } else {
            // If UnsavedChecker is not available, allow navigation
            next();
        }
    },
};
